import { useAdminApi } from '@hooks/useAdminApi';
import { RJSFSchema } from '@rjsf/utils';
import { toastifyService } from '@services/ToastifyService';
import { useCallback, useEffect, useState } from 'react';
import { transformParams } from '../../tradingAdminUtils';

export const useTradingOtcForm = () => {
  const { apiClient } = useAdminApi();

  const [formSchema, setFormSchema] = useState<RJSFSchema>();
  const [formData, setFormData] = useState<Record<string, any>>();

  const onFormChange = useCallback((data: Record<string, any>) => {
    const { formData } = data;
    if (!formData) return;

    setFormData(formData);
  }, []);

  const onFormSubmit = useCallback(async () => {
    if (!apiClient || !formData) return;

    try {
      const response = await apiClient?.updateTradingOtcParams(formData);
      if (response) toastifyService.showSuccess('OTC params updated successfully');
    } catch (error: any) {
      const errorMessage = error.data.detail[0].msg || 'Failed to update OTC params';
      toastifyService.showError(errorMessage);
    }
  }, [apiClient, formData]);

  useEffect(() => {
    const fetchTradingOtcParamsSchema = async () => {
      const params = await apiClient?.getTradingParamsSchema();
      if (!params) return;

      const { components } = params;
      const { schemas } = components;
      const OTCParams = schemas['OtcParams-Output'];
      if (!OTCParams) return;

      const transformedParams = transformParams(OTCParams, schemas);
      setFormSchema(transformedParams);
    };

    const fetchCurrentOtcParams = async () => {
      const OTCParams = await apiClient?.getTradingOtcParams();
      if (!OTCParams) return;

      const { params, id } = OTCParams;
      setFormData({ ...params, id });
    };

    fetchTradingOtcParamsSchema();
    fetchCurrentOtcParams();
  }, [apiClient]);

  return { formSchema, formData, onFormChange, onFormSubmit };
};
